ACDiscountAppSubtotal.PDPage.DisplayTiers = function () {

var storeTime = globalFieldsSub.Storetime();
// Parse the date string into individual components
 let [currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds] = storeTime.split(/[\sT:-]/);
 currentYear = parseInt(currentYear);
 currentMonth = parseInt(currentMonth); // Months are zero-based in JavaScript
 currentDay = parseInt(currentDay);
 currentHours = parseInt(currentHours);
 currentMinutes =parseInt(currentMinutes);
 currentSeconds = parseInt(currentSeconds);

  function makeTimer(end_date) {
    if(globalFieldsSub.isProduct_Page){
      if(end_date != null){
      jQuery("#ac_countDown").css("display", "block");
        var endTime =  end_date;
      // Increment seconds by 1
       currentSeconds++;
      
      // Adjust minutes, hours, and day if necessary
      if (currentSeconds >= 60) {
          currentSeconds = 0;
          currentMinutes++;
          if (currentMinutes >= 60) {
              currentMinutes = 0;
              currentHours++;
              if (currentHours >= 24) {
                  currentHours = 0;
                  currentDay++;
              }
          }
      }
      
          // Reformat the updated timestamp
          let currentStoreTime = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}T${currentHours.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}:${currentSeconds.toString().padStart(2, '0')}`;
          endTime = (Date.parse(endTime) / 1000);
          var now = currentStoreTime;
          now = (Date.parse(now) / 1000);
        
          var timeLeft = endTime - now;
          var days = Math.floor(timeLeft / 86400); 
          var hours = Math.floor(timeLeft / 3600);
          var exactHour = hours % 24;
          var minutes = Math.floor((timeLeft - (hours * 3600 )) / 60);
          var seconds = Math.floor((timeLeft - (hours * 3600) - (minutes * 60)));
          var isDays = false;
          if (days > 0 || hours > 24){isDays = true;}
          if (days < 0) { days = "00"; /*hours = "0"; minutes = "0"; seconds = "0";*/ }
          if (hours < 10) { hours = "0" + hours; }
          if (minutes < 10) { minutes = "0" + minutes; }
          if (seconds < 10) { seconds = "0" + seconds; }
          if(timeLeft > 0){
            if(isDays){
              $(".ac__days").html(days); $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes);
              $(".ac_sec, .ac__colon.seconds").hide();
            }
            else{
              $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes); $(".ac__seconds").html(seconds);		
              $(".ac_day, .ac__colon.hours").hide(); $(".ac_sec, .ac__colon.seconds").show();
            }
          }
          else{jQuery('.ac__settings__Subtotal_table, #ac_countDown').remove();}
        
        setTimeout(function () {
          jQuery('.ac__settings__Subtotal_table').after(jQuery("#ac_countDown"));
        }, 500);
      }
    }
}   


  var hide_buttons = null;
  var HideAdditionalPayments = function() {      
    hide_buttons = setInterval(function() {
     
      if(jQuery('.shopify-payment-button__button').length>0){
        jQuery('.shopify-payment-button__button').hide();
        clearInterval(hide_buttons);
      }
    }, 500);
  }

  function checkDiscountId(discounts,id) {
  const found = discounts.some(discount => discount.id === id);
  return !found; // Return false if found, else true
}
  
  this.DisplayTiersFn = function () {
      setTimeout(function () {
          jQuery('.ac__settings__Subtotal_table').remove();
          var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
          let ProductPage = globalFieldsSub.TableProductPage != undefined && globalFieldsSub.TableProductPage != '' ? globalFieldsSub.TableProductPage : 'true';
          ProductPage = ProductPage == 'true' ? true : false;
        if (selectedVariant != null && ProductPage) {
             var tierObj = globalFieldsSub.GetTierObject(globalFieldsSubtotalProductPage_AC.productMetafield, selectedVariant);
            if (tierObj != undefined && tierObj.status && checkDiscountId(tierObj.excludeProducts,globalFieldsSub.productId) && globalFieldsSub.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
              var getDates = globalFieldsSub.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = undefined;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
              if(timer_settings != undefined){                
                if(timer_settings.TimerStatus){  
                  if(getDates.valid){
                      setInterval(function() { makeTimer(getDates.end_date); }, 1000);
                  }
                }
              }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function(){
                  jQuery('.shopify-payment-button__button').hide();
                  HideAdditionalPayments();
                }, 2000);
                setTimeout(function(){
                  clearInterval(hide_buttons);
                }, 5000);
              }
          }
      }, 200);
  }
  
  setTimeout(function(){
    clearInterval(hide_buttons);
  }, 10000);

  this.OnVariantChange = function () {
      setTimeout(function () {
          $(".single-option-selector,.single-option-selector__radio").change(function () {
              displayTiers.DisplayTiersFn();
          });
      }, 2000);
  }
  



  var TableHeadHtml = function (contentHtml, tableSelector, position) {
   jQuery(tableSelector)[globalFieldsSub.settings.beforeOrAfterCartButton == 'after' ? 'after' : 'before'](contentHtml);
  }

  var WriteTableHeading = function (tierObj) {
  
    var tableSelector = '.product__info-wrapper .product-form';
      if (globalFieldsSub.settings.currentTable == "table1") {
          TableHeadHtml(`<div class="update-sub-tatal"><table class="ac__settings__Subtotal_table ac_table6" id="ac_table6"><div class="tabl"><tbody class="ac__tbody" ><div class="updated-tbl"><p class="get-more-pay less" style="color: ${globalFieldsSub.settings.TitleHeadingFontColor || 'white'};background-color: ${globalFieldsSub.settings.TitleBackGroundColor || 'red'};font-weight: ${globalFieldsSub.settings.TitleBodyTextWeight || 'normal'};text-align: ${globalFieldsSub.settings.TitleHeadingAlignItem || 'center'};">${ globalFieldsSub.settings.TitleHeadingText }</p><tr class="ac__tr ac__tr1"> </tr></div></tbody></div></table></div>`, tableSelector);
      }
      if (globalFieldsSub.settings.currentTable == "table2") {

          // TableHeadHtml('<table class="ac__settings__Subtotal_table ac_table7" id="ac_table7"><div class="tabl"><tbody class="ac__tbody"><div class="updated-tbl"><p class="get-more-pay less">' + globalFieldsSub.settings.TitleHeadingText +'</p></div><tr class="ac__tr ac__tr1"> <td>'+ globalFieldsSub.settings.spendAmountHeading+'</td> <td>'+ globalFieldsSub.settings.discountYouGetHeading+'</td></tr></div></tbody></table>', tableSelector);
          TableHeadHtml(`<div class="discount-offer"><h2  style="color: ${globalFieldsSub.settings.TitleHeadingFontColor || 'white'};background-color: ${globalFieldsSub.settings.TitleHeadingBackGroundColor || 'red'};font-weight: ${globalFieldsSub.settings.TitleHeadingTextWeight || 'normal'};text-align: ${globalFieldsSub.settings.TitleHeadingTexAlignItem || 'center'};">${globalFieldsSub.settings.TitleHeadingText }</h2><table  class="ac__settings__Subtotal_table ac_table7" id="ac_table7" style="text-align: ${globalFieldsSub.settings.TexFontType || 'center'} !important;"><thead style="color:${globalFieldsSub.settings.amountShowColor};"><tr ><th>${globalFieldsSub.settings.spendAmountHeading}</th><th>${globalFieldsSub.settings.discountYouGetHeading}</th></tr></thead><tbody class="ac__tbody" style="font-weight: ${globalFieldsSub.settings.bodyTextWeight};"></tbody></table></div>`, tableSelector);
        // TableHeadHtml(' <div class="update-sub-tatal"><table class="ac__settings__Subtotal_table ac_table2" id="ac_table2"><div class="tabl"><tbody class="ac__tbody"> <div class="updated-tbl"><p class="get-more-pay less">' + globalFieldsSub.settings.TitleHeadingText +'</p><tr class="ac__tr ac__tr1"></tr></div></tbody></div></table></div>', tableSelector);
      }
  }

  var TableRowHtml = function (contentHtml, tableSelector) {
      jQuery(tableSelector).append(contentHtml);
  }

  var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff, index) {
     
      var plusSign = tieredMin_ == tieredMax_ ? '' : '+', buyText = 'Buy ';
      var priceHtml = '<span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + discountedPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(discountedPrice, globalFieldsSub.amount) + '</span>';
      if (globalFieldsSub.settings.currentTable == "table1") {
          TableRowHtml(`<tr class="ac__tr ac__tr${index + 1 }"> <td class="ac__td ac__td1" style="background-color: ${globalFieldsSub.settings.BodyBackGroundColor || 'white'} !important;color: ${globalFieldsSub.settings.BodyFontColor || 'black'} !important;font-size: ${globalFieldsSub.settings.BodyFontSize || '10'}px !important;font-weight: ${globalFieldsSub.settings.BodyTextWeight || 'normal'} !important;text-align: ${globalFieldsSub.settings.BodyTexAlignItem || 'center'} !important;">${globalFieldsSub.settings.spendAmount}  ${tieredMin_ }  ${globalFieldsSub.settings.customerGet }</td><td class="ac__td ac__td2" style="background-color: ${globalFieldsSub.settings.BodyBackGroundColor || 'white'} !important;color: ${globalFieldsSub.settings.BodyFontColor || 'black'} !important;font-size: ${globalFieldsSub.settings.BodyFontSize || '10'}px !important;font-weight: ${globalFieldsSub.settings.BodyTextWeight || 'normal'} !important;text-align: ${globalFieldsSub.settings.BodyTexAlignItem || 'center'} !important;"> ${tieredOff}  ${globalFieldsSub.settings.savingMessage }</td></tr>`, '#ac_table6 .ac__tbody');
      }

      if (globalFieldsSub.settings.currentTable == "table2") {
        
      // TableRowHtml('<tr class="ac__tr ac__tr' + index + '"> <td class="ac__td ac__td1">' + globalFieldsSub.settings.spendAmount + ' ' + tieredMin_ + ' ' + globalFieldsSub.settings.spendMoreAmount + '</td><td class="ac__td ac__td2"> ' + globalFieldsSub.settings.andGet  + ' '+ tieredOff + '</td></tr>', '#ac_table7 .ac__tbody');
      TableRowHtml(` <tr style="color: ${globalFieldsSub.settings.amountShowColor};"><td style="font-size: ${globalFieldsSub.settings.fontSize}px;">${globalFieldsSub.settings.spendAmount }  ${tieredMin_ }  ${globalFieldsSub.settings.spendMoreAmount }</td><td style="font-size: ${globalFieldsSub.settings.fontSize}px;"> ${globalFieldsSub.settings.andGet }  ${tieredOff } </td></tr>`, '#ac_table7 .ac__tbody');
          // TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">'   +globalFieldsSub.settings.spendAmount + ' '+ tieredMin_+' '+ globalFieldsSub.settings.customerGet +  '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3" >' + tieredOff + ' ' +globalFieldsSub.settings.savingMessage +'</td></tr>', '#ac_table2 .ac__tbody');
    
      }

  }

  var WriteTableRows = function (tierObj, selectedVariant_) {
      var originalPrice_ = globalFieldsSubtotalProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
      for (i = 0; i < tierObj.tier_min.length; i++) {
          var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]);
          var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;

          if (tieredMax_ != "max") {
              tieredMax_ = parseInt(tieredMax_);
          }
          else {
              tieredMax_ = "+";
          }

          if (tierObj.discount_type == "percentage") {
              discountedPrice = Number(originalPrice_.toFixed(2));
              var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
              discountedPrice = discountedPrice - originalPriceCut_;
              if (discountedPrice <= 0) {
                  discountedPrice = 0;
                  tieredOff = "100%";
                  isBreakLoop = true;
                  tieredMax_ = "";
              }
              else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = tieredOff + "% OFF";
              }
          }
          else if (tierObj.discount_type == "fixed_price") {
              discountedPrice = tieredOff.toFixed(2);
              tieredOff = globalFieldsSub.formatMoney(tieredOff.toFixed(2), globalFieldsSub.amount);
          }
          else {
//                 discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
//                 if (discountedPrice <= 0) {
//                     discountedPrice = 0;
//                     tieredOff = globalFieldsSub.formatMoney(originalPrice_.toFixed(2), globalFieldsSub.amount);
//                     isBreakLoop = true;
//                     tieredMax_ = "+";
//                 }
//                 else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = globalFieldsSub.formatMoney(tieredOff.toFixed(2), globalFieldsSub.amount) + " OFF";
//                 }
          } 

            tieredMin_ = tierObj.DiscountBasedOn == 'Range of Quantities' ? `${tieredMin_} Quantity`: globalFieldsSub.formatMoney(tieredMin_.toFixed(2), globalFieldsSub.amount) ;
          TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff, i + 1);

          if (isBreakLoop) { break; }
      }
  }

}

var globalFieldsSubtotalProductPage_AC = new ACDiscountAppSubtotal.PDPage.Global(), displayTiers = new ACDiscountAppSubtotal.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();